import { createFileRoute } from "@tanstack/react-router";
import TmsParklandFl from "@/pages/local/TmsParklandFl";
export const Route = createFileRoute("/tms-parkland-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Parkland Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy for patients near Parkland, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:title",
          content: "TMS Parkland Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy for patients near Parkland, FL. SAINT TMS, standard TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs. Free benefits verification.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-parkland-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-parkland-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsParklandFl />;
}
